import ServicePage from "../Common/ServicePage";

// Bathroom Fittings specific services
const bathroomFittingsServices = [
  { 
    id: 1, 
    name: 'Basic Bathroom Fittings Install', 
    provider: 'BathPro Experts', 
    image: 'https://placehold.co/600x400?text=Basic+Fittings', 
    rating: 4.78, 
    reviews: 380, 
    price: 500, 
    category: 'Basic Installation' 
  },
  { 
    id: 2, 
    name: 'Full Bathroom Fittings Setup', 
    provider: 'EliteBath Professionals', 
    image: 'https://placehold.co/600x400?text=Full+Setup', 
    rating: 4.85, 
    reviews: 250, 
    price: 1200, 
    category: 'Full Setup' 
  },
  { 
    id: 3, 
    name: 'Shower Installation Service', 
    provider: 'ShowerCare Solutions', 
    image: 'https://placehold.co/600x400?text=Shower+Install', 
    rating: 4.80, 
    reviews: 320, 
    price: 300, 
    category: 'Shower Installation' 
  },
  { 
    id: 4, 
    name: 'Toilet Seat Installation', 
    provider: 'ToiletPro Specialists', 
    image: 'https://placehold.co/600x400?text=Toilet+Seat', 
    rating: 4.82, 
    reviews: 280, 
    price: 350, 
    category: 'Toilet Installation' 
  },
  { 
    id: 5, 
    name: 'Bathroom Tap Installation', 
    provider: 'TapMasters', 
    image: 'https://placehold.co/600x400?text=Tap+Installation', 
    rating: 4.76, 
    reviews: 420, 
    price: 200, 
    category: 'Tap Installation' 
  },
  { 
    id: 6, 
    name: 'Bathroom Mirror Installation', 
    provider: 'MirrorFit Experts', 
    image: 'https://placehold.co/600x400?text=Mirror+Install', 
    rating: 4.79, 
    reviews: 190, 
    price: 250, 
    category: 'Mirror Installation' 
  },
  { 
    id: 7, 
    name: 'Bathroom Cabinet Installation', 
    provider: 'CabinetPro Services', 
    image: 'https://placehold.co/600x400?text=Cabinet+Install', 
    rating: 4.83, 
    reviews: 150, 
    price: 400, 
    category: 'Cabinet Installation' 
  },
  { 
    id: 8, 
    name: 'Geyser Installation Service', 
    provider: 'GeyserInstall Experts', 
    image: 'https://placehold.co/600x400?text=Geyser+Install', 
    rating: 4.81, 
    reviews: 350, 
    price: 600, 
    category: 'Geyser Installation' 
  },
  { 
    id: 9, 
    name: 'Bathroom Exhaust Fan Installation', 
    provider: 'VentPro Professionals', 
    image: 'https://placehold.co/600x400?text=Exhaust+Fan', 
    rating: 4.77, 
    reviews: 220, 
    price: 350, 
    category: 'Ventilation' 
  },
  { 
    id: 10, 
    name: 'Bathroom Shelving Installation', 
    provider: 'ShelfMasters', 
    image: 'https://placehold.co/600x400?text=Shelving+Install', 
    rating: 4.84, 
    reviews: 180, 
    price: 280, 
    category: 'Shelving' 
  },
  { 
    id: 11, 
    name: 'Bathroom Towel Rail Installation', 
    provider: 'RailFit Solutions', 
    image: 'https://placehold.co/600x400?text=Towel+Rail', 
    rating: 4.75, 
    reviews: 160, 
    price: 180, 
    category: 'Accessories' 
  },
  { 
    id: 12, 
    name: 'Bathroom Lighting Installation', 
    provider: 'BathLight Experts', 
    image: 'https://placehold.co/600x400?text=Bathroom+Lighting', 
    rating: 4.86, 
    reviews: 270, 
    price: 320, 
    category: 'Lighting' 
  }
];

const bathroomFittingsCategories = ['Basic Installation', 'Full Setup', 'Shower Installation', 'Toilet Installation', 'Tap Installation', 'Mirror Installation', 'Cabinet Installation', 'Geyser Installation', 'Ventilation', 'Shelving', 'Accessories', 'Lighting'];

const packages = [
  { id: 1, title: "Basic Bathroom Fittings Install", rating: "4.78 (380 reviews)", price: 500, originalPrice: 650, icon: "🚿" },
  { id: 2, title: "Full Bathroom Fittings Setup", rating: "4.85 (250 reviews)", price: 1200, originalPrice: 1500, icon: "🛁" },
];

const miniServices = [
  { id: 101, title: "Shower Installation", price: 300, icon: "💦" },
  { id: 102, title: "Toilet Seat Installation", price: 350, icon: "🚽" },
];

export default function BathroomFittings() {
  return (
    <ServicePage
      serviceName="Bathroom Fittings"
      packages={packages}
      miniServices={miniServices}
      customServices={bathroomFittingsServices}
      customCategories={bathroomFittingsCategories}
      isCustomService={true}
    />
  );
}